import { render, staticRenderFns } from "./BetslipItem.vue?vue&type=template&id=3bcc2844"
import script from "./BetslipItem.vue?vue&type=script&lang=js"
export * from "./BetslipItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports